var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.employmentOptions,
      multiple: _vm.multiple,
      invalid: _vm.invalid,
      loading: _vm.$apollo.queries.postings.loading,
      placeholder: "Select type",
      withoutLoading: "",
    },
    on: { search: (v) => (_vm.searchString = v), input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }